'use client';

import { useLocale } from 'next-intl';
import { type PrefetchKind } from 'next/dist/client/components/router-reducer/router-reducer-types';
import { useEffect, useRef } from 'react';

import { useRouter } from '@module/mdrt-org/shared/i18n/i18n-navigation';
import prefetchPaths from '@module/mdrt-org/shared/utils/data/graphql/_generated/prefetch-paths.json';
import { scheduleWhenIdle } from '@module/mdrt-org/shared/utils/helpers/schedule-when-idle';

const FULL_PREFETCH = { kind: 'full' as PrefetchKind };

export const PrefetchWarmer = () => {
  const router = useRouter();
  const locale = useLocale();
  const warmedLocaleRef = useRef<null | string>(null);

  useEffect(() => {
    if (warmedLocaleRef.current === locale) {
      return () => undefined;
    }

    if (window.PUBLIC_ENV?.disableNextPrefetchFeature === 'true') {
      return () => undefined;
    }

    warmedLocaleRef.current = locale;

    return scheduleWhenIdle(() => {
      for (const path of prefetchPaths) {
        router.prefetch(path, FULL_PREFETCH);
      }
    });
  }, [locale, router]);

  return null;
};
